/* Playful Blocks — small helpers shared by all pb-* sections.
   Safe to include from several sections: it only initialises once,
   and re-initialises sections reloaded in the theme editor. */
(function () {
  if (window.__pbInit) return;
  window.__pbInit = true;

  function pad(n) { return ('0' + n).slice(-2); }

  /* Product gallery: click a thumbnail to swap the main image */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-pb-thumb]');
    if (!t) return;
    var g = t.closest('[data-pb-gallery]');
    var main = g && g.querySelector('[data-pb-main]');
    if (!main) return;
    main.src = t.getAttribute('data-src');
    main.removeAttribute('srcset');
    main.alt = t.getAttribute('data-alt') || '';
    g.querySelectorAll('[data-pb-thumb]').forEach(function (b) {
      b.classList.toggle('is-active', b === t);
      b.setAttribute('aria-pressed', b === t ? 'true' : 'false');
    });
  });

  document.addEventListener('change', function (e) {
    /* Bundle picker: sets the quantity sent to the cart */
    var r = e.target.closest('[data-pb-bundle]');
    if (r) {
      var q = document.getElementById(r.getAttribute('data-qty-target'));
      if (q) q.value = r.value;
    }
    /* Variant picker: updates the price shown in the same section */
    var s = e.target.closest('[data-pb-variant]');
    if (s) {
      var opt = s.options[s.selectedIndex];
      var sec = s.closest('.pb');
      sec.querySelectorAll('[data-pb-price-now]').forEach(function (el) { el.textContent = opt.getAttribute('data-price'); });
      sec.querySelectorAll('[data-pb-price-was]').forEach(function (el) {
        var was = opt.getAttribute('data-compare');
        el.textContent = was || '';
        el.hidden = !was;
      });
      sec.querySelectorAll('[data-pb-buy]').forEach(function (b) {
        var ok = opt.getAttribute('data-available') === 'true';
        b.disabled = !ok;
        var label = ok ? b.getAttribute('data-label') : b.getAttribute('data-soldout');
        if (label) b.textContent = label;
      });
    }
  });

  /* Countdown: <span data-pb-countdown="2026-11-30T23:59:00"> */
  function tick() {
    document.querySelectorAll('[data-pb-countdown]').forEach(function (el) {
      var raw = (el.getAttribute('data-pb-countdown') || '').trim().replace(' ', 'T');
      var end = Date.parse(raw);
      var wrap = el.closest('[data-pb-countdown-wrap]');
      if (isNaN(end)) { if (wrap) wrap.hidden = true; return; }
      var d = Math.max(0, end - Date.now());
      if (d === 0 && wrap && wrap.hasAttribute('data-hide-when-done')) { wrap.hidden = true; return; }
      var days = Math.floor(d / 86400000);
      var h = Math.floor(d % 86400000 / 3600000);
      var m = Math.floor(d % 3600000 / 60000);
      var sec = Math.floor(d % 60000 / 1000);
      el.textContent = (days > 0 ? days + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(sec);
    });
  }
  tick();
  setInterval(tick, 1000);

  /* Rotating announcement messages */
  setInterval(function () {
    document.querySelectorAll('[data-pb-rotate]').forEach(function (w) {
      var ms = w.children;
      if (ms.length < 2) return;
      var i = 0;
      for (var k = 0; k < ms.length; k++) if (ms[k].classList.contains('is-active')) i = k;
      ms[i].classList.remove('is-active');
      ms[(i + 1) % ms.length].classList.add('is-active');
    });
  }, 4500);

  /* Sticky add-to-cart bar: shows once the main button scrolls away */
  function initSticky() {
    document.querySelectorAll('[data-pb-sticky]').forEach(function (bar) {
      if (bar.__pbReady) return;
      bar.__pbReady = true;
      var target = document.getElementById(bar.getAttribute('data-watch'));
      if (!target || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        bar.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
      }).observe(target);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSticky);
  else initSticky();
  document.addEventListener('shopify:section:load', function () { initSticky(); tick(); });
})();
